import config from '@/config/user.env';
import volacnoBasePoint from './volcanoEngineCls.js';
const VOLC_ENGINE_SDK = 'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/collect-autotrack-rangers-v4.1.54.js';
const CHANNEL = 'https://iotsdk.midea.com';
/* eslint-disable */
export const injectInitIncident = (win, export_obj) => {
    win['TeaAnalyticsObject'] = export_obj;
    if (!win[export_obj]) {
        function _collect() {
            _collect.q.push(arguments);
        }
        _collect.q = _collect.q || [];
        win[export_obj] = _collect;
    }
    win[export_obj].l = +new Date();
};

export const loadVolacnoBasePoint = () => {
    injectInitIncident(window, 'collectEvent');
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.setAttribute = 'async';
        script.src = VOLC_ENGINE_SDK;
        document.head.appendChild(script);
        script.onload = () => {
            resolve();
        };
        script.onerror = reject;
    });
};

export default function initVolacnoBasepoint(params = {}) {
    loadVolacnoBasePoint().then(() => {
        window.collectEvent('init', {
            app_id: Number(config.volacnoBasePointAPPID),
            channel_domain: CHANNEL,
            log: true,
            enable_ab_test: true,
            autotrack: false,
            ...params
        });
        window.collectEvent('start');
        volacnoBasePoint.initUserCode();
    });
};

